import {
  fetchRequest,
  securedFetchRequest,
} from '@bidmii/common/lib/util/FetchRequest';
import {API_URL} from '../../../../../constants';
import PrimaryButton from '../../../../../common/StyledComponents/PrimaryButton';
import {Typography} from '@mui/material';

export default function StripeHomeownerCustomerAccount() {
  const handleClickManagePaymentMethods = async () => {
    const requestFunction =
      process.env.REACT_APP_FORCE_WEB_VIEW === '1' ||
      (window as $TSFixMe).ReactNativeWebView
        ? fetchRequest
        : securedFetchRequest;
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    };
    if (
      process.env.REACT_APP_FORCE_WEB_VIEW === '1' ||
      (window as $TSFixMe).ReactNativeWebView
    ) {
      // @ts-expect-error
      options.headers['Firebase-Authorization'] = sessionStorage.getItem(
        'Firebase-Authorization',
      );
    }

    requestFunction(`${API_URL}/user-customer-account-session`, options)
      .then((res) => res.text())
      .then((text) => {
        window.location.href = text;
      });
  };

  return (
    <div className="container">
      <div className="content">
        <Typography variant="h6" gutterBottom>
          Manage your payment methods
        </Typography>
        <Typography variant="body2" mb={2}>
          Bidmii uses stripe payments to ensure your money is always secured.
        </Typography>
        <PrimaryButton onClick={handleClickManagePaymentMethods}>
          MANAGE
        </PrimaryButton>
      </div>
    </div>
  );
}
